import PropTypes from 'prop-types';
import classNames from 'classnames';

import './styles.scss';

const ChartTooltip = ({ active, payload, valueFormatter }) => {
  if (active && payload && payload.length) {
    const deltaClasses = classNames('chart-custom-tooltip__delta', {
      'chart-custom-tooltip__delta--positive': payload[0].payload.delta > 0,
      'chart-custom-tooltip__delta--negative': payload[0].payload.delta < 0
    });
    return (
      <div className="chart-custom-tooltip">
        <p className="chart-custom-tooltip__label">
          {valueFormatter(payload[0].value)}
        </p>
        {payload[0]?.payload?.delta && (
          <p className={deltaClasses}>{payload[0].payload.delta}%</p>
        )}
      </div>
    );
  }

  return null;
};

ChartTooltip.propTypes = {
  active: PropTypes.bool.isRequired,
  payload: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      payload: PropTypes.shape({
        delta: PropTypes.number
      })
    })
  ).isRequired,
  valueFormatter: PropTypes.func.isRequired
};

export default ChartTooltip;
